import React, { useRef, useState } from "react";
import DashboardHeader from "../../components/Other/DashboardHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import ProfileTop from "../components/MyProfile/ProfileTop";
import {
  faBookmark as saved,
  faEdit,
  faTrash,
  faEllipsisV,
  faPlay,
  faPause,
} from "@fortawesome/free-solid-svg-icons";
import {
  getProfile,
  getMyPost,
  savePost,
  tradingType,
  followUnfollow,
  repostPost,
  getComment,
  addComment,
  likeDislike,
  deletePost,
  getSettings,
  getPaymentCardsApi,
  makePaymentApi,
  setPrimaryMethod,
  getPaidPost,
  deleteComment,
  undoRepostPost,
  createPaymentIntent,
} from "../../api/user";
import { useEffect } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { faHeart as empty } from "@fortawesome/free-regular-svg-icons";
import { faComment as empty2 } from "@fortawesome/free-regular-svg-icons";
// import logo from "../images/logo.png";
import GreenTick from "../../images/green-tick.png";
import { faBookmark } from "@fortawesome/free-regular-svg-icons";
import {
  faLink,
  faEllipsisH,
  faArrowUpFromBracket,
  faHeart,
  faRepeat,
} from "@fortawesome/free-solid-svg-icons";
import Loader from "../../components/Loader";
import PageContainer from "../../components/pages/PageContainer";
import PageHeaderTitle from "../../components/pages/PageHeaderTitle";
import SubscriptionModal from "../../pages/stripe-payment/subscriptionModal";
import CardListForSubs from "../../pages/stripe-payment/card-detail-listing";
import AddCard from "../../pages/stripe-payment/addCard";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../../pages/stripe-payment/stripePayment";
import { loadStripe } from "@stripe/stripe-js";
import List from "../../pages/stripe-payment/list";
import SmallLoader from "../../components/smallLoader";
import { event } from "../../utils/event";
import UndoRepostModal from "../../components/Modals/repostModal";
import { PreviewVideo } from "../../pages/previewVideo";
import { formatPrice, SUBSCRIPTION_ENABLED } from "../../utils/utils";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import PhotoSwipeLightbox from "photoswipe/lightbox";
import "photoswipe/style.css";
import { Link, useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import GameSideBar from "../Games/GameSideBar";
import ResetPortfolioModal from "../Modals/ResetPortfolioModal";
import CheckoutPortfolioForm from "../Modals/CheckoutPortfolioForm";
import PortfolioLoader from "../Modals/PortfolioLoader";
import Flag from "react-world-flags";
import {  IconExit,
  CommentIcon,
  HeartFilledIcon,
  HeartIcon,
  RepostIcon,
  SaveIcon,
  ShareIcon,
  TheDotsIcon,
  SaveIconFill } from "../../icons/icons";
import { COUNTRIES } from "../../icons/countryFlag";

const galleryStyles = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
  gridGap: "20px",
};

const imageStyles = {
  width: "auto",
  height: "auto",
  objectFit: "cover",
  // border: "1px solid #ccc",
};

const linkStyles = {
  // background: "#f0f0f0",
  // padding: "5px",
  margin: "10px",
};

function calculateTimeDifference(created_at) {
  const currentDate = new Date();
  const createdAtDate = new Date(created_at);

  // Ensure time difference is non-negative
  const timeDifference = Math.max(
    0,
    currentDate.getTime() - createdAtDate.getTime()
  );

  const secondsInMs = 1000;
  const minutesInMs = secondsInMs * 60;
  const hoursInMs = minutesInMs * 60;
  const daysInMs = hoursInMs * 24;
  const monthsInMs = daysInMs * 30; // Note: Approximation, as months have varying numbers of days
  const yearsInMs = daysInMs * 365; // Note: Does not account for leap years

  if (timeDifference < secondsInMs) {
    return "just now";
  } else if (timeDifference < minutesInMs) {
    return Math.round(timeDifference / secondsInMs) + " s ago";
  } else if (timeDifference < hoursInMs) {
    return Math.round(timeDifference / minutesInMs) + " m ago";
  } else if (timeDifference < daysInMs) {
    return Math.round(timeDifference / hoursInMs) + " h ago";
  } else if (timeDifference < monthsInMs) {
    return Math.round(timeDifference / daysInMs) + " d ago";
  } else if (timeDifference < yearsInMs) {
    // Change 'm' to 'mo' to avoid confusion with 'minutes'
    return Math.round(timeDifference / monthsInMs) + " mo ago";
  } else {
    return Math.round(timeDifference / yearsInMs) + " y ago";
  }
}

const ProfilePage = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const game_id = props.game_id ?? null;
  const slug = props.slug ?? null;
  const profile_id = props.profile_id ?? null;
  const [posts, setPosts] = useState([]);
  const [profile, setProfile] = useState([]);
  const [commentOpenStates, setCommentOpenStates] = useState({});
  const [newComment, setNewComment] = useState("");
  const [newid, setNewId] = useState("");
  const [postComments, setPostComments] = useState({});
  const [userImg, setUserImg] = useState("");
  const [trading, setTrade] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [isSubscribe, setIsSubscribe] = useState(false);
  const [isOpenCardModal, setIsOpenCardModal] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [stripeKey, setStripeKey] = useState("");
  const [cards, setCards] = useState([]);
  const [isChecked, setIsChecked] = useState(false);
  const [isDataFeteched, setisDataFeteched] = useState(false);
  const [isDataFeteched1, setisDataFeteched1] = useState(false);
  const [isDataFeteched2, setisDataFeteched2] = useState(false);
  const [isDataFeteched3, setisDataFeteched3] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showFullDescription, setShowFullDescription] = useState([]);
  const [dropdownStates, setDropdownStates] = useState(posts.map(() => false));
  const [videoPlaying, setVideoPlaying] = useState([]);
  const [page, setPage] = useState(1);
  const openModal = () => setIsAddModalOpen(true);
  const closeModal = () => setIsAddModalOpen(false);
  const stripePromise = stripeKey && loadStripe(stripeKey);
  let { userId } = useParams();
  const user_id = localStorage.getItem("user_id");
  const [traderProfile, setTraderProfile] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [loader, setLoader] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [showFullRepostDescription, setShowFullRepostDescription] = useState(
    []
  );
  const [isHovered, setIsHovered] = useState(false);
  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);
  const [loadingComment, setLoadingComment] = useState(false);
  const [last_page, setlast_page] = useState();
  const isMobileView = document.body.clientWidth <= 768; // You can adjust the breakpoint as needed
  const [preview, setPreview] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const videoExtensionsRegex = /\.(mp4|mov|avi|wmv)$/i;
  const [isPreviewVideo, setIsPreviewVideo] = useState(false);
  const [attachments, setAttachments] = useState("");
  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const [sidebarToggle] = useOutletContext();
  const [postUndo, setPostUndo] = useState(false);
  const [postUndoId, setPostUndoID] = useState("");
  const [showVideos, setShowVideos] = useState(
    new Array(posts?.length).fill(false)
  );
  const videoRefs = useRef([]);
  const [activeButtons, setActiveButtons] = useState("");
  const [isPortfolioResetModalOpen, setIsPortfolioResetModalOpen] =
    useState(false);
  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);
  const [clientSecret, setClientSecret] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isFlutterWebViewReady, setIsFlutterWebViewReady] = useState(false);
  const [deviceType, setDeviceType] = useState("Unknown");


  //For Video

  const videosRef = useRef({});
  const [playing, setPlaying] = useState({});
  const [isMuted, setIsMuted] = useState(true); // Global mute state
   const [playingVideoId, setPlayingVideoId] = useState(null);
   const [isLoadingVideo, setIsLoadingVideo] = useState(true); // Track loading state
   const hasScrolledRef1 = useRef(false);
  const [pausedVideoId, setPausedVideoId] = useState(null);


useEffect(() => {
  hasScrolledRef1.current = false; // ✅ Reset when route changes
}, [location.pathname]); // ✅ Runs when path changes


// const handleVideoCanPlay = (id) => {
//   //  alert('tpss');
//   requestAnimationFrame(() => {
//     window.scrollBy(0, 1);
//     requestAnimationFrame(() => window.scrollBy(0, -1)); // Move back up
//   });
//   setIsLoadingVideo((prev) => ({ ...prev, [id]: false }));
// };

const handleVideoCanPlay = (id, isVisible) => {
  const video = videosRef.current[id];
  console.log(video,'video i am getting are');
  if (!hasScrolledRef1.current) {
    hasScrolledRef1.current = true; // ✅ Set flag to prevent future runs
    if (isVisible) {
      video.play().catch((e) => console.warn("Autoplay blocked:", e));
      setPlaying((prev) => ({ ...prev, [id]: true }));
    } else {
      video.pause();
      setPlaying((prev) => ({ ...prev, [id]: false }));
    }
  }

  setIsLoadingVideo((prev) => ({ ...prev, [id]: false }));
};

  // useEffect(() => {
  //   const video = videosRef.current[posts.id];
  //   if (video) {
  //     video.load(); // ✅ Force browser to load video immediately
  //   }
  // }, []);

const handleVisibility = (id, isVisible) => {
  const video = videosRef.current[id];
  if (video) {
    if (isVisible) {
      video.play().catch((e) => console.warn("Autoplay blocked:", e));
      setPlaying((prev) => ({ ...prev, [id]: true }));
    } else {
      video.pause();
      setPlaying((prev) => ({ ...prev, [id]: false }));
    }
  }
};


  console.log("videosRef.current", videosRef.current);
    useEffect(() => {
    if (document.body.clientWidth <= 768) return; // Skip for mobile

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.getAttribute("data-id");
          handleVisibility(id, entry.isIntersecting);
        });
      },
      { threshold: 0.75 } // Trigger when 75% of video is visible
    );

    // ✅ Attach observer to each video
    Object.values(videosRef.current).forEach((video) => {
      if (video) observer.observe(video);
    });

    return () => {
      Object.values(videosRef.current).forEach((video) => {
        if (video) observer.unobserve(video);
      });
      observer.disconnect();
    };
  }, [posts]); // Runs when posts change

const checkVideosInView = () => {
  let newPlayingVideoId = playingVideoId; // Keep track of the current playing video
console.log("videosRef.current12", videosRef.current);
  Object.entries(videosRef.current).forEach(([id, video]) => {
    if (video) {
      const rect = video.getBoundingClientRect();
      const videoHeight = rect.bottom - rect.top;
      const videoVisibleHeight = Math.min(window.innerHeight, rect.bottom) - Math.max(0, rect.top);

      // Check if at least 10% of the video is visible in the viewport
      const isAtLeast10PercentVisible = videoVisibleHeight / videoHeight >= 0.1;
      const completelyOutOfView = rect.bottom <= 0 || rect.top >= window.innerHeight;

      if (isAtLeast10PercentVisible) {
        newPlayingVideoId = id;
      }

      if (completelyOutOfView && playingVideoId === id) {
        video.pause();
        setPausedVideoId(null);
        newPlayingVideoId = null;
      }
    }
  });

  // If a new video should be played, play it and update state
  if (newPlayingVideoId !== playingVideoId) {
    Object.values(videosRef.current).forEach((v) => v?.pause());
    if (newPlayingVideoId) {
      videosRef.current[newPlayingVideoId]?.play().catch(() => console.warn("Autoplay blocked"));
      // setPausedVideoId(null);
    }
    setPlayingVideoId(newPlayingVideoId);

            // 🧠 Clear the play icon if it's no longer on the currently playing video

      if (pausedVideoId && pausedVideoId !== playingVideoId) {
        setPausedVideoId(null);
      }
  }
};

// Attach scroll event listener
useEffect(() => {
  checkVideosInView(); // Check on mount
  window.addEventListener("scroll", checkVideosInView);

  return () => {
    window.removeEventListener("scroll", checkVideosInView);
  };
}, [playingVideoId]);



const togglePlay = (id) => {
  const video = videosRef.current[id];
  if (video) {
    const isPlaying = playing[id] ?? false; // default to false
    if (isPlaying) {
    //  alert('in if');
      video.pause();
      setPausedVideoId(id); // show overlay
    } else {
    //  alert('in else');
      video.play();
      setPausedVideoId(null); // hide overlay
    }

    setPlaying((prev) => ({ ...prev, [id]: !isPlaying }));
  }
};


  // const togglePlay = (id) => {
  //   const video = videosRef.current[id];
  //   if (video) {
  //     if (playing[id]) {
  //       video.pause();
  //     } else {
  //       video.play();
  //     }
  //     setPlaying((prev) => ({ ...prev, [id]: !prev[id] }));
  //   }
  // };

  const toggleMute = () => {
    setIsMuted((prevMuted) => {
      const newMuteState = !prevMuted;
      Object.values(videosRef.current).forEach((video) => {
        if (video) video.muted = newMuteState;
      });
      return newMuteState;
    });
  };



  useEffect(() => {
    const userAgent = navigator.userAgent;

    let device_type = "Unknown";

    if (/Android/i.test(userAgent)) {
      device_type = "A";
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      device_type = "I";
    } else {
      device_type = "W";
    }

    setDeviceType(device_type);

    // Check if device type is iOS from local storage
    const flutterWebView = localStorage.getItem("isFlutterInAppWebViewReady");
    setIsFlutterWebViewReady(flutterWebView === "true");
  }, []); // Run once when component mounts

  const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

  const stripeResetPromise = loadStripe(STRIPE_PUBLISHABLE_KEY);

  function getUserIdFromPath() {
    const path = window.location.pathname; // Get the current path
    const parts = path.split("/"); // Split the path into parts
    return parts[parts.length - 1]; // Return the last part (userId)
  }

  if (slug) {
    userId = getUserIdFromPath();
  }

  useEffect(() => {
    localStorage.setItem("toggle", "true");
    let lightbox = new PhotoSwipeLightbox({
      gallery: ".pswp-gallery",
      children: "a",
      pswpModule: () => import("photoswipe"),
    });
    lightbox.init();

    return () => {
      lightbox.destroy();
      lightbox = null;
    };
  }, [posts]);

  useEffect(() => {
    if (userId) {
      if (userId !== user_id) {
        setTraderProfile(true);
      } else {
        setTraderProfile(false);
      }
    } else {
      setTraderProfile(false);
    }
  }, [userId, user_id]);

  useEffect(() => {
    if (!isDataFeteched) getCards();
  }, [isDataFeteched]);

  useEffect(() => {
    if (!isDataFeteched1) fetchProfile();
  }, [userId, isDataFeteched1]);

  useEffect(() => {
    if (!isDataFeteched2) fetchTrading();
  }, [isDataFeteched2]);

  useEffect(() => {
    if (!isDataFeteched3) fetchSetting();
  }, [isDataFeteched3]);

  // Used for dismiss a modal
  useEffect(() => {
    const handleDismissEvent = () => {
      console.log("Modal dismiss event received");
      setIsPortfolioResetModalOpen(false);
    };

    window.addEventListener("myDismissModalEvent", handleDismissEvent);

    return () => {
      window.removeEventListener("myDismissModalEvent", handleDismissEvent);
    };
  }, []);

  const handleImageLoaded = (event, imageIndex) => {
    const image = event.target;
    const linkElement = image.closest("a");
    linkElement.setAttribute("data-pswp-width", image.naturalWidth);
    linkElement.setAttribute("data-pswp-height", image.naturalHeight);
  };

  const handleLoadMore = async () => {
    try {
      const body = { user_id: userId ? userId : user_id, page };
      setLoader(true);
      const response = await getMyPost(body);
      if (response?.data?.status === 200) {
        setPosts((prevPosts) => [...prevPosts, ...response.data.data.data]);
        setPage((pagePre) => pagePre + 1);
        setLoader(false);
      } else {
        setHasMore(false);
        setLoader(false);
      }
    } catch (error) {
      console.error("Error fetching more data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
    // setItemsPerPage(itemsPerPage + 10);
    // setPage(page + 1);
    // const body = { user_id: userId ? userId : user_id, page };
    // try {
    //   const response = await getMyPost(body);
    //   if (response?.data?.status == 200) {
    //     setPosts((prevPosts) => [...prevPosts, ...response.data.data.data]);
    //     setlast_page(response?.data?.data?.last_page);
    //     setLoading(false);
    //   }
    // } catch (error) {
    //   console.error("Error:", error);
    // }
  };

  const getCards = async () => {
    const res = await getPaymentCardsApi();
    if (res?.data?.status === 200) {
      const card = res?.data?.data?.data.find((val) => val.is_active);
      setIsChecked(card?.is_active);
      setCards(res?.data?.data?.data);
      setisDataFeteched(true);
    } else {
      setisDataFeteched(false);
      console.log(res?.data?.message);
    }
  };

  const fetchProfile = async () => {
    try {
      let response;
      if (profile_id) {
        response = await getProfile(profile_id, game_id);
      } else if (userId) {
        response = await getProfile(userId, game_id);
      } else {
        response = await getProfile();
      }
      if (response?.data?.data) {
        setisDataFeteched1(true);
        const profileData = response.data.data;
        if (!userId) {
          localStorage.setItem(
            "userInfo",
            JSON.stringify(response?.data?.data)
          );
          localStorage.setItem("img", response?.data?.data?.image);
          const myCustomEvent = new CustomEvent("profileEvent", {
            detail: {
              profileImg: response?.data?.data?.image,
              profileData: response?.data?.data,
            },
          });
          window.dispatchEvent(myCustomEvent);
        }

        if (profileData.game_notification > 0) {
          localStorage.setItem(
            "notificationCount",
            profileData.game_notification
          );
        }

        setProfile(profileData);
        setUserImg(profileData.image);
        fetchPost(profileData.id, 1);
      }
    } catch (error) {
      setLoading(false);
      setisDataFeteched1(false);
      console.error("Error:", error);
    }
  };

  const fetchTrading = async () => {
    try {
      const response = await tradingType();
      if (response) {
        setisDataFeteched2(true);
        setTrade(response.data.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleFollow = async (id) => {
    const body = {
      user_uuid: id,
      request_status: 2,
    };
    setIsDisabled(true);
    try {
      const response = await followUnfollow(body);

      if (response.status === 200) {
        // console.log(response.data);
        if (response.data.status === 400) {
          setIsDisabled(false);
          toast.error(response.data.message);
        } else {
          setIsDisabled(false);
          fetchProfile();
        }
      }
    } catch (error) {
      setIsDisabled(false);
      console.error("Error:", error);
    }
  };

  const handleUnfollow = async (id) => {
    const body = {
      user_uuid: id,
      request_status: 1,
    };
    setIsDisabled(true);
    try {
      const response = await followUnfollow(body);
      if (response.status === 200) {
        // console.log(response.data);
        setIsDisabled(false);
        fetchProfile();
      }
    } catch (error) {
      console.error("Error:", error);
      setIsDisabled(false);
    }
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleMouseEnter1 = () => {
    setIsHovered1(true);
  };

  const handleMouseLeave1 = () => {
    setIsHovered1(false);
  };

  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };

  const renderButton = () => {
    if (userId) {
      return (
        <div
          className={
            isMobileView
              ? "flex flex-col"
              : "flex flex-col mx-4 md:flex-row md:space-x-2 md:mx-20"
          }
        >
          <div className="flex-grow">
            {profile?.is_follow_by_me ? (
              <button
                onClick={() => handleUnfollow(profile.uuid)}
                disabled={isDisabled ? true : false}
                type="button"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{
                  color: isHovered ? "white" : "#004c50",
                  background: isHovered ? "#004C50" : "white",
                  width: "100%",
                  border: "1px solid #004c50",
                  borderRadius: "8px",
                  fontSize: "0.875rem",
                  padding: "0.59rem 1.05rem",
                  textAlign: "center",
                  // marginRight: '0.5rem',
                  marginBottom: "0.5rem",
                  outline: "none",
                  transition: "background-color 0.2s, border-color 0.2s",
                }}
                className="font-bold"
                // className="text-primaryColor bg-white w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold bg-primaryColor dark:bg-primaryColor"
              >
                FOLLOWING
              </button>
            ) : (
              <button
                type="button"
                onClick={() => handleFollow(profile.uuid)}
                disabled={isDisabled ? true : false}
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
                style={{
                  color: isHovered ? "white" : "#004c50",
                  background: isHovered ? "#004C50" : "white",
                  width: "100%",
                  border: "1px solid #004c50",
                  borderRadius: "8px",
                  fontSize: "0.875rem",
                  padding: "0.59rem 1.05rem",
                  textAlign: "center",
                  // marginRight: '0.5rem',
                  marginBottom: "0.5rem",
                  outline: "none",
                  transition: "background-color 0.2s, border-color 0.2s",
                }}
                className="font-bold"
                // className="text-primaryColor w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold"
              >
                FOLLOW
              </button>
            )}
          </div>
          <div className="flex-grow">
            <button
              type="button"
              onClick={() => handleclick(profile)}
              onMouseEnter={handleMouseEnter1}
              onMouseLeave={handleMouseLeave1}
              style={{
                color: isHovered1 ? "white" : "#004c50",
                background: isHovered1 ? "#004C50" : "white",
                width: "100%",
                border: "1px solid #004c50",
                borderRadius: "8px",
                fontSize: "0.875rem",
                padding: "0.59rem 1.05rem",
                textAlign: "center",
                // marginRight: '0.5rem',
                marginBottom: "0.5rem",
                outline: "none",
                transition: "background-color 0.2s, border-color 0.2s",
              }}
              className="font-bold"
              // className="text-primaryColor w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold"
            >
              MESSAGE
            </button>
          </div>
          {profile?.green_tick && SUBSCRIPTION_ENABLED && (
            <div
              className="flex-grow"
              onClick={() => {
                if (profile?.is_subscribed) {
                  navigate(`/paid-content/${userId}`);
                }
              }}
            >
              <button
                type="button"
                onClick={() => {
                  fetchPaidPost(profile?.id);
                }}
                className="text-primaryColor w-full hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-green-300 rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-primaryColor dark:text-primaryColor dark:hover:text-white dark:hover:primaryColor dark:focus:ring-green-800 font-bold"
              >
                PAID CONTENT
              </button>
            </div>
          )}
        </div>
      );
    }
    return null;
  };

  const fetchPaidPost = async (id) => {
    setLoading(true);
    const body = { user_id: id, post_status: 2 };
    try {
      const response = await getPaidPost(body);
      if (response.data.status === 400) {
        // console.log(response);
        toast.error(response.data.message);
        setLoading(false);
      } else {
        // console.log(response);
        setPosts(response.data.data.data);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };

  const handleclick = (chat) => {
    // console.log(chat, "chat");
    localStorage.setItem("id", chat.id);
    localStorage.setItem("image", chat.image);

    if (game_id) {
      navigate(`/${slug}/chatHistory/${chat.id}`);
    } else {
      navigate(`/chatHistory/${chat.id}`);
    }
  };

  const handleCommentToggle = async (index, id, isOpen) => {
    setLoadingComment(true);
    try {
      isOpen = isOpen !== undefined ? isOpen : !commentOpenStates[index];

      if (!isOpen) {
        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: false,
        }));
        return;
      }
      const response = await getComment(id);
      if (response.status === 200) {
        setTimeout(() => {
          setLoadingComment(false);
        }, 1000);
        setCommentOpenStates((prevStates) => {
          const newState = {};
          Object.keys(prevStates).forEach((key) => {
            newState[key] = false;
          });
          return newState;
        });

        const sortedChats = response?.data?.data.sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );

        setPostComments((prevComments) => ({
          ...prevComments,
          [id]: sortedChats,
        }));

        setCommentOpenStates((prevStates) => ({
          ...prevStates,
          [index]: isOpen,
        }));
      }
    } catch (error) {
      setLoadingComment(false);
      console.error("Error fetching comments:", error);
    }
  };

  const handleAddComment = async (postId, index) => {
    if (newComment.length <= 255) {
      setIsDisabled(true);
      // console.log(postId);
      const body = {
        post_id: postId,
        comment: newComment,
      };
      try {
        const response = await addComment(body);
        // console.log(response, "res");
        if (response.status === 200) {
          fetchPost(profile.id, 1);
          await getComment(postId);
          handleCommentToggle(index, postId, true);
          setCommentOpenStates((prevStates) => ({
            ...prevStates,
            [postId]: false,
          }));
          setIsDisabled(false);
          setNewComment("");
        }
        if (!response.ok) {
          setIsDisabled(false);
          throw new Error("Failed to add a comment");
        }
      } catch (error) {
        setIsDisabled(false);
        console.error(error);
        // Handle error
      }
    } else {
      toast.error("Comment should be less that or equal to 255 characters.");
    }
  };

  const fetchPost = async (id, page) => {
    const body = { user_id: id, page };
    try {
      const response = await getMyPost(body);
      if (response?.data?.status == 200) {
        setPosts(response?.data?.data?.data);
        setPage((pagePre) => pagePre + 1);
        setlast_page(response?.data?.data?.last_page);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error("Error:", error);
    }
  };

  const handleSavePost = async (postId) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id == postId) {
        val.is_saved = !val.is_saved;
      } else if (val?.repost?.id == postId) {
        val.repost.is_saved = !val.repost.is_saved;
      }
      return val;
    });
    setPosts(postssss);
    // console.log(postId);
    setIsDisabled(true);
    try {
      // Make API call to update like/dislike status
      const response = await savePost(postId);
      // console.log(response, "res");
      if (response.status === 200) {
        // toast.success(response.data.message);
        fetchPost(postId, 1);
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        setIsDisabled(false);
        const postssss = posts.map((val) => {
          if (val?.id == postId) {
            val.is_saved = false;
          } else if (val?.repost?.id == postId) {
            val.repost.is_saved = false;
          }
          return val;
        });
        setPosts(postssss);
        throw new Error("Failed to save post");
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
      // Handle error
    }
  };

  const handleLikeDislike = async (postId, isLiked) => {
    const postssss = posts.map((val) => {
      if (!val?.repost?.id && val?.id == postId) {
        val.is_like_by_me = !val.is_like_by_me;
        val.total_likes =
          val.is_like_by_me == true ? val.total_likes + 1 : val.total_likes - 1;
      } else if (val?.repost?.id == postId) {
        val.repost.is_like_by_me = !val.repost.is_like_by_me;
        val.repost.total_likes =
          val.repost.is_like_by_me == true
            ? val.repost.total_likes + 1
            : val.repost.total_likes - 1;
      }
      return val;
    });
    setPosts(postssss);
    setIsDisabled(true);
    try {
      const response = await likeDislike(postId);
      // console.log(response, "res");
      if (response.status === 200) {
        // toast.success(response.data.message);
        fetchPost(profile.id, 1);
        setIsDisabled(false);
      }
      if (response.status !== 200) {
        const postssss = posts.map((val) => {
          if (val?.id == postId) {
            val.is_like_by_me = false;
            val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
          } else if (val?.repost?.id == postId) {
            val.repost.is_like_by_me = false;
            val.repost.total_likes =
              val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
          }
          return val;
        });
        setPosts(postssss);
        setIsDisabled(false);
        throw new Error("Failed to update like/dislike status");
      }
    } catch (error) {
      const postssss = posts.map((val) => {
        if (val?.id == postId) {
          val.is_like_by_me = false;
          val.total_likes = val.total_likes > 0 ? val.total_likes - 1 : 0;
        } else if (val?.repost?.id == postId) {
          val.repost.is_like_by_me = false;
          val.repost.total_likes =
            val.repost.total_likes > 0 ? val.repost.total_likes - 1 : 0;
        }
        return val;
      });
      setPosts(postssss);
      setIsDisabled(false);
      console.error(error);
      // Handle error
    }
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleDeletePost = async (postId) => {
    // console.log(postId);
    handleOpenModal();
    setNewId(postId);
  };

  const handleEditClick = (postId) => {
    navigate(`/edit-post/${postId}`);
  };

  const handleClick = () => {
    setActiveButtons("EditProfile");
    navigate("/edit-profile");
  };

  const userInfo = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : {};

  const handleDelete = async () => {
    setIsDisabled(true);
    try {
      const response = await deletePost(newid);
      if (response.status === 200) {
        setIsDisabled(false);
        setPosts((prevPosts) =>
          prevPosts.filter((post) =>
            post?.repost?.id ? post?.repost?.id !== newid : post.id !== newid
          )
        );
        // toast.success("Post deleted successfully");
        fetchPost(profile.id, 1);
        handleCloseModal();
      } else {
        setIsDisabled(false);
        throw new Error("Failed to delete the post");
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
    }
  };

  const toggleDropdown = (index) => {
    const newDropdownStates = [...dropdownStates];
    newDropdownStates[index] = !newDropdownStates[index];
    setDropdownStates(newDropdownStates);
  };
  // const toggleDropdown = (index) => {
  //   setDropdownStates(prevStates => {
  //     const newDropdownStates = prevStates.map((state, i) => {
  //       // Close any other open dropdown except for the clicked one
  //       return i === index ? !state : false;
  //     });
  //     return newDropdownStates;
  //   });
  // };
  // const toggleDescription = () => {
  //   setShowFullDescription(!showFullDescription);
  // };

  const handleUndoRepost = async () => {
    try {
      const res = await undoRepostPost(postUndoId);
      if (res.status === 200) {
        fetchPost(profile.id, 1);
        setPostUndo(false);
        setIsDisabled(false);
      }
      if (!res.ok) {
        setIsDisabled(false);
      }
    } catch (error) {
      setIsDisabled(false);
      console.error(error);
    }
  };

  const handleUndoCancel = () => {
    setPostUndo(false);
  };

  const handleRepost = async (postId, obj, id) => {
    if (obj?.repost?.id) {
      setPostUndoID(id);
      setPostUndo(true);
    } else {
      setIsDisabled(true);
      try {
        const response = await repostPost(postId);
        if (response.status === 200) {
          fetchPost(profile.id, 1);
          setIsDisabled(false);
        }
        if (!response.ok) {
          setIsDisabled(false);
          throw new Error("Failed to update like/dislike status");
        }
      } catch (error) {
        setIsDisabled(false);
        console.error(error);
      }
    }
  };

  const handleSubscription = () => {
    setIsSubscribe(true);
  };

  const handleSubscribeCard = () => {
    setIsOpenCardModal(true);
    setIsSubscribe(false);
  };

  const handleSubscribeCancel = () => {
    setIsSubscribe(false);
  };

  const fetchSetting = async () => {
    try {
      const response = await getSettings();
      if (response) {
        setisDataFeteched3(true);
        setStripeKey(response.data.data.pk_key);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handlePaymentCard = async (val) => {
    if (cards && cards.length > 0) {
      setIsButtonDisabled(true);
      const card = cards.find((val) => val.is_active);
      const obj = {
        payment_method_id: card?.id,
        follower_id: userId,
        // "type":"card",
        // "token":"tok_visa",
        // "name_on_card":val.name_on_card,
        // "last_four_digit":"5678"
      };
      const res = await makePaymentApi(obj);
      if (res?.data?.status === 200) {
        setIsSubscribe(false);
        setIsOpenCardModal(false);
        setIsAddModalOpen(false);
        fetchProfile();
        setIsButtonDisabled(false);
        toast.success(res?.data?.message);
      } else {
        setIsButtonDisabled(false);
        toast.error(res?.data?.message);
      }
    } else {
      setIsButtonDisabled(false);
      toast.error("You have to add a card to make payments");
    }
  };

  const handlePaymentCancel = () => {
    setIsSubscribe(false);
    setIsOpenCardModal(false);
    setIsAddModalOpen(false);
  };

  const handlePrimaryValue = async (val) => {
    const res = await setPrimaryMethod(val?.id);
    if (res?.data?.status === 200) {
      getCards();
    } else {
      toast.error(res?.data?.message);
    }
  };

  const handleDeleteComment = async (id) => {
    setIsDisabled(true);
    try {
      const response = await deleteComment(id);
      if (response.status === 200) {
        // toast.success("Comment deleted successfully");
        fetchPost(profile?.id, 1);
        handleCommentToggle(true);
        setLoading(false);
        setIsDisabled(false);
      } else {
        setIsDisabled(false);
        throw new Error("Failed to delete the post");
      }
    } catch (error) {
      setLoading(false);
      setIsDisabled(false);
      console.error(error);
    }
  };
  const selectedTradingStyle =
    (trading &&
      trading.length > 0 &&
      trading.find((option) => option.id === profile.trading_type_id)?.type) ||
    "";

  // const handleShare = async (id) => {
  //   const urlToShare = `https://app.qushi.io/feed/${id}`;

  //   const shareData = {
  //     title: "QUSHI",
  //     text: "Check out this!",
  //     url: urlToShare,
  //   };

  //   try {
  //     if (navigator.share) {
  //       await navigator.share(shareData);
  //       // console.log("Data was shared successfully");
  //     } else {
  //       // Fallback for browsers that do not support navigator.share
  //       // You could copy the link to clipboard or display a modal with share options
  //       console.error("Web Share API is not supported in your browser.");
  //     }
  //   } catch (err) {
  //     console.error("Error sharing:", err);
  //   }
  // };


  const handleShare = async (id) => {
    const urlToShare = `https://app.qushi.io/feed/${id}`;

    const shareData = {
      title: "QUSHI",
      text: "Check out this!",
      url: urlToShare,
    };
    try {
      if (navigator.share) {
        await navigator.clipboard.writeText(urlToShare);
        await navigator.share(shareData);
      } else {
        const el = document.createElement("textarea");
        el.value = urlToShare;
        document.body.appendChild(el);
        el.select();
        document.execCommand("copy");
        document.body.removeChild(el);
        const shareLinkPrompt = `Link copied\nShare this link: ${urlToShare}`;
        alert(shareLinkPrompt);
      }
    } catch (err) {
      console.error("Error sharing:", err);
    }
  };

  const renderDescriptionDynamicLineBreaks = (description) => {
    // Check if description is null or undefined
    if (!description || description == null) {
      return null;
    }

    // Regular expression to match one or more newline characters
    const regex = /(\n+)/g;

    // Split the description by the regex, keeping the delimiter
    const parts = description.split(regex);

    return parts.map((part, index) => {
      if (part.match(regex)) {
        // For newline characters, return a series of <br /> elements equal to the count of \n minus 1
        return [...Array(part.length - 1)].map((_, brIndex) => (
          <br key={`br-${index}-${brIndex}`} />
        ));
      } else {
        // For regular text, return a paragraph
        return <p key={`text-${index}`}>{part}</p>;
      }
    });
  };
  const handleLinkClick = (link) => {
    const flutterMobile = localStorage.getItem("isFlutterInAppWebViewReady");
    if (flutterMobile) {
      event("profile", link);
    }
  };
  const portfolioNavi = (cash) => {
    if (userId && !game_id) {
      localStorage.setItem("totalCash", cash);
      navigate(`/portfolio/${userId}`, {
        state: { game_id: game_id },
      });
    } else if (userId && game_id) {
      localStorage.setItem("totalCash", cash);

      if (game_id) {
        navigate(`/${slug}/portfolio/${profile_id}`);
      } else {
        navigate(`/portfolio`);
      }
    } else {
      navigate(`/portfolio`);
    }
  };

  const navigateToFollowers = (user_name) => {
    if (!game_id) {
      if (userId) {
        navigate(`/followers/${userId}`, { state: { user_name } });
      } else {
        navigate(`/followers/${user_id}`, { state: { user_name } });
      }
    }
    if (game_id) {
      if (userId) {
        navigate(`/${slug}/followers/${userId}`, { state: { user_name } });
      }
    }
  };

  const navigateToPortfolio = (user_name) => {
    if (userId) {
      navigate(`/performance/${userId}`, { state: { user_name } });
    } else {
      navigate(`/performance/${user_id}`, { state: { user_name } });
    }
  };

  const handleVideoClick1 = (postIndex, imageIndex) => {
    const key = `${postIndex}-${imageIndex}`;
    const videoRef = videoRefs.current[key];

    if (videoRef) {
      if (videoPlaying[key]) {
        videoRef.pause();
        setVideoPlaying((prev) => ({ ...prev, [key]: false }));
      } else {
        // Pause all other videos
        Object.keys(videoRefs.current).forEach((otherKey) => {
          if (otherKey !== key && videoRefs.current[otherKey]) {
            videoRefs.current[otherKey].pause();
            setVideoPlaying((prev) => ({ ...prev, [otherKey]: false }));
          }
        });
        videoRef
          .play()
          .then(() => {
            setVideoPlaying((prev) => ({ ...prev, [key]: true }));
          })
          .catch((error) => {
            console.error("Error playing video:", error);
          });
      }
    } else {
      setVideoPlaying((prev) => ({ ...prev, [key]: true }));
      const updatedShowVideos = [...showVideos];
      updatedShowVideos[postIndex] = true;
      if (videoRef) {
        videoRef.play();
      }
      setShowVideos(updatedShowVideos);
      console.warn(`No videoRef found for key: ${key}`);
    }
  };

  // const getVideoThumbnail = (videoUrl) => {
  //     const video1 = videoUrl + ".jpg";
  //     return video1;
  // };
  const handleCloseVideoClick = () => {
    setIsPreviewVideo(false);
    setAttachments("");
  };

  useEffect(() => {
  setIsLoadingVideo((prevLoadingState) => {
    const newLoadingState = { ...prevLoadingState }; // Preserve previous state
    posts.forEach((post) => {
      if (!(post.id in newLoadingState)) {
        newLoadingState[post.id] = true; // Set only for new posts
      }
    });
    return newLoadingState;
  });
}, [posts]);

  const showPreview = (image) => {
    setActiveImage(image);
    setPreview(true);
  };

  const resetPortfolio = () => {
    setIsPortfolioResetModalOpen(true); // Open the portfolio reset modal
    //   setTimeout(() => {
    //   const myCustomEvent = new Event("myDismissModalEvent");
    //   window.dispatchEvent(myCustomEvent);
    // }, 3000);
  };

  // Function to close the modal (Cancel action)
  const closeResetPortfolioModal = () => {
    setIsPortfolioResetModalOpen(false); // Close the modal
  };

  // Function to handle confirmation (Confirm action)
  const handleConfirm = async () => {
    if (deviceType === "I" && isFlutterWebViewReady) {
      event("IAP");
      return;
    }

    setIsLoading(true); // Start loading
    try {
      const response = await createPaymentIntent();

      if (response?.data?.clientSecret) {
        const { clientSecret } = response.data;
        setClientSecret(clientSecret); // Store the clientSecret
        setIsPortfolioResetModalOpen(false); // Close the modal
        setIsStripeModalOpen(true); // Open the Stripe modal
      } else {
        console.error("No clientSecret found in response");
      }
    } catch (error) {
      console.error("Error fetching payment intent:", error);
      // Optionally handle user-facing error message
    } finally {
      setIsLoading(false); // Stop loading
    }
  };

  const handleStripeModalClose = () => {
    setIsStripeModalOpen(false); // Close the Stripe modal
  };

  // const videoRefs = useRef([]);
  return (
    <>
      <DashboardHeader toggle={sidebarToggle} />
      {!loading ? (
        <>
          <PageHeaderTitle title="Profile" />
          <PageContainer gamePage={game_id && true}>
            {slug && (
              <>
                <GameSideBar
                  gamePage={game_id && true}
                  activeMenu=""
                  slug={slug}
                />
              </>
            )}

            <div
              className={`md:block  rounded-2xl bg-white w-full max-w-[60rem] mx-auto`}
            >
              <main className="h-full bg-white  md:ml-8 ml-0  justify-center">
                {/* <div className="p-2 md:p-8 rounded-2xl border bg-[#FBFCFC] border-white-500 max-w-[60rem] mx-auto"> */}
                <div className="flex flex-col  lg:mx-16 md:py-2  space-y-3">
                  <div className="flex justify-between items-center  flex-row md:text-base text-sm	">
                    <div>
                      <img
                        src={userImg}
                        alt="userImage"
                        className="w-16 h-16 md:w-24 md:h-24 rounded-full object-cover"
                      />
                    </div>
                    <div
                      className=" flex flex-col items-center	font-bold	cursor-pointer"
                      onClick={() =>
                        navigateToPortfolio(
                          profile && profile?.user_name
                            ? "@" + profile?.user_name
                            : profile.full_name
                        )
                      }
                    >
                      <h1
                        className={` whitespace-nowrap font-poppins font-extrabold ${
                          profile.performance < 0
                            ? "text-[20px] text-red-600"
                            : "text-[20px] text-greenXD"
                        }`}
                      >
                        {profile.performance}%{" "}
                        {profile.performance < 0 ? "" : "+"}
                      </h1>

                      <h1 className="text-[#707070]">Performance</h1>
                    </div>
                    <div
                      className=" flex flex-col items-center font-bold cursor-pointer"
                      onClick={() => {
                        portfolioNavi(
                          profile?.wallet_coin
                            ? profile?.wallet_coin.toFixed(2)
                            : ""
                        );
                      }}
                    >
                      {!loading && traderProfile ? (
                        <h1
                          className={`text-[20px] font-poppins font-bold ${
                            profile.wallet_coin < 0
                              ? "text-red-600"
                              : "text-greenXD"
                          }`}
                        >
                          {formatPrice(profile.wallet_coin)}
                          {/* {new Intl.NumberFormat("en-US", {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          }).format(Math.floor(profile.wallet_coin))} */}
                        </h1>
                      ) : (
                        !loading && (
                          <h1
                            className={
                              profile.wallet_coin > 999999
                                ? `text-[15px] font-poppins font-bold ${
                                    profile.wallet_coin < 0
                                      ? "text-red-600"
                                      : "text-greenXD"
                                  }`
                                : `text-[20px] font-poppins font-bold ${
                                    profile.wallet_coin < 0
                                      ? "text-red-600"
                                      : "text-greenXD"
                                  }`
                            }
                          >
                            {profile.wallet_coin > 0 ? (
                              <span>{formatPrice(profile.wallet_coin)}</span>
                            ) : (
                              <span>
                                {Number(profile.wallet_coin).toFixed(2)}
                              </span>
                            )}
                          </h1>
                        )
                      )}

                      <h1 className="text-[#707070]">Portfolio</h1>
                    </div>
                    <div
                      className=" flex flex-col items-center font-bold cursor-pointer"
                      onClick={() =>
                        navigateToFollowers(
                          profile && profile?.user_name
                            ? "@" + profile?.user_name
                            : profile.full_name
                        )
                      }
                    >
                      <h1 className="text-[20px] text-greenXD  font-extrabold">
                        {profile.follower_count === 0
                          ? "0"
                          : profile.follower_count}
                      </h1>
                      <h1 className="text-[#707070]">Followers</h1>
                    </div>
                  </div>
                  {/* <span className="px-1 ml-0 sm:ml-[16] text-[17px] text-black font-bold font-poppins whitespace-nowrap">
                    {profile && profile?.user_name
                      ? "@" + profile?.user_name
                      : profile.full_name}{" "}
                      {
                        COUNTRIES.filter(item => item.iso2 === profile.country_code).length > 0
                        ? COUNTRIES.filter(item => item.iso2 === profile.country_code).map(item => (
                            <span className="inline ml-2" style={{ width: 24, height: "auto" }}  key={item.iso2}>{item.flag}</span>
                          ))
                        : <Flag code={profile.country_code} style={{ width: 23, height: "auto" }} className="inline ml-2" />
                      }
                  </span> */}
                  <span className="px-1 ml-0 sm:ml-[16] text-[17px] text-black font-bold font-poppins whitespace-nowrap">
  {profile && profile?.user_name
    ? "@" + profile?.user_name
    : profile.full_name}{" "}

  {
    COUNTRIES.some(item => item.iso2 === profile.country_code)
      ? COUNTRIES.filter(item => item.iso2 === profile.country_code).map(item => (
          item.flag.startsWith("/") ? (
            // If flag is a PNG path, render an <img> tag
            <img
              key={item.iso2}
              src={item.flag}
              alt={item.name}
              width="24"
              height="16"
              className="inline ml-2"
              onError={(e) => { e.target.src = "/flags/default.png"; }} // Fallback flag
            />
          ) : (
            // If flag is an emoji, render a <span>
            <span className="inline ml-2" key={item.iso2}>{item.flag}</span>
          )
        ))
      : <Flag code={profile.country_code} style={{ width: 23, height: "auto" }} className="inline ml-2" />
  }
</span>


                  <div>
                    <h1>{profile.title}</h1>
                  </div>
                  <div className="flex space-x-3">
                    <h1 className="text-[#707070]">Trading Style</h1>
                    <span className="w-[156px] text-[#707070] ml-12 whitespace-nowrap">
                      {selectedTradingStyle}
                    </span>
                  </div>
                  <h1 className="text-[#707070]">{profile?.biography}</h1>

                  {userId && user_id !== userId && (
                    <div className="flex">
                      {profile?.link && profile?.link !== "null" && (
                        <>
                          <FontAwesomeIcon icon={faLink} className="mt-1" />
                          <a
                            href={
                              profile?.link &&
                              (profile.link.startsWith("http")
                                ? profile?.link
                                : `https://${profile?.link}`)
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="ml-1 text-[#71AB59]"
                            onClick={() => handleLinkClick(profile.link)}
                          >
                            {isMobileView ? (
                              <p className="text-xs font-bold">
                                {profile?.link}
                              </p>
                            ) : (
                              <strong>{profile?.link}</strong>
                            )}
                          </a>
                        </>
                      )}
                    </div>
                  )}

                  {isMobileView && !userId && (
                    <>
                      {profile?.link && profile?.link !== "null" && (
                        <div className="mb-2 flex  items-center">
                          <FontAwesomeIcon icon={faLink} className="mr-2" />
                          <a
                            href={
                              profile.link.startsWith("http")
                                ? profile.link
                                : `https://${profile.link}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#71AB59] break-all whitespace-normal"
                            onClick={() => handleLinkClick(profile.link)}
                            style={{ maxWidth: "100%" }}
                          >
                            {isMobileView ? (
                              <p className="text-xs font-bold">
                                {profile?.link}
                              </p>
                            ) : (
                              <strong>{profile?.link}</strong>
                            )}
                          </a>
                        </div>
                      )}

                      {!game_id && (
                        <div className="flex justify-center mb-4 px-2 gap-2">
                          <button
                            onClick={handleClick}
                            className={`w-full px-4 py-2 rounded-l-md  focus:outline-none transition-colors ${
                              activeButtons === "EditProfile"
                                ? "bg-primaryColor text-white border"
                                : "bg-white text-[#8A8B8F] border  border-black"
                            } ${isMobileView && "text-xs"}`}
                          >
                            Edit Profile
                          </button>
                          <button
                            onClick={() => {
                              setActiveButtons("Watchlist");
                              navigate("/search");
                            }}
                            className={`w-full px-4 py-2 rounded-r-md  focus:outline-none transition-colors ${
                              activeButtons === "Watchlist"
                                ? "bg-primaryColor text-white border "
                                : "bg-white text-[#8A8B8F]  border border-black"
                            } ${isMobileView && "text-xs"}`}
                          >
                            Watchlist
                          </button>
                          <button
                            onClick={() => {
                              resetPortfolio();
                            }}
                            className={`w-full px-4 py-2 rounded-r-md  focus:outline-none transition-colors ${
                              activeButtons === "Reset Portfolio"
                                ? "bg-primaryColor text-white border "
                                : "bg-white text-[#8A8B8F]  border border-black"
                            } ${isMobileView && "text-xs"}`}
                          >
                            QUSHi Bank
                          </button>
                        </div>
                      )}
                    </>
                  )}

                  {!game_id && userId === user_id ? (
                    <div className="flex space-x-3 items-center">
                      <button
                        onClick={handleClick}
                        type="button"
                        className=" text-primaryColor font-poppins hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-primaryColor-300  rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-green-500 dark:text-primaryColor dark:hover:text-white dark:hover:bg-primaryColor dark:focus:ring-green-800 font-bold"
                      >
                        Edit Profile
                      </button>
                    </div>
                  ) : !game_id && !isMobileView && !userId ? (
                    <div className="flex space-x-3  items-center top-0">
                      <button
                        onClick={handleClick}
                        type="button"
                        className="flex-shrink-0 text-primaryColor font-poppins hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-primaryColor-300  rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-green-500 dark:text-primaryColor dark:hover:text-white dark:hover:bg-primaryColor dark:focus:ring-green-800 font-bold"
                      >
                        Edit Profile
                      </button>
                      <button
                        onClick={resetPortfolio}
                        type="button"
                        className=" text-primaryColor font-poppins hover:text-white border border-primaryColor hover:bg-primaryColor focus:ring-4 focus:outline-none focus:ring-primaryColor-300  rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2 dark:border-green-500 dark:text-primaryColor dark:hover:text-white dark:hover:bg-primaryColor dark:focus:ring-green-800 font-bold"
                      >
                        QUSHi Bank
                      </button>
                      {profile?.link && profile?.link !== "null" && (
                        <div className="mb-2 flex  items-center">
                          <FontAwesomeIcon icon={faLink} className="mr-2" />
                          <a
                            href={
                              profile.link.startsWith("http")
                                ? profile.link
                                : `https://${profile.link}`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-[#71AB59] break-all whitespace-normal"
                            onClick={() => handleLinkClick(profile.link)}
                            style={{ maxWidth: "100%" }}
                          >
                            {isMobileView ? (
                              <p className="text-xs font-bold">
                                {profile?.link}
                              </p>
                            ) : (
                              <strong>{profile?.link}</strong>
                            )}
                          </a>
                        </div>
                      )}
                    </div>
                  ) : (
                    userId !== user_id && ""
                  )}

                  {SUBSCRIPTION_ENABLED ? (
                    userId === user_id ? (
                      <div>
                        <button
                          type="button"
                          // onClick={handleSubscription}
                          onMouseEnter={handleMouseEnter2}
                          onMouseLeave={handleMouseLeave2}
                          style={{
                            color: isHovered2 ? "white" : "#004c50",
                            background: isHovered2 ? "#004C50" : "white",
                            width: "100%",
                            border: "1px solid #004c50",
                            borderRadius: "8px",
                            fontSize: "0.875rem",
                            padding: "0.59rem 1.05rem",
                            textAlign: "center",
                            outline: "none",
                            marginBottom: "0.5rem",
                            transition:
                              "background-color 0.2s, border-color 0.2s",
                          }}
                          className="font-bold"
                        >
                          SUBSCRIPTIONS{" "}
                          <span className="rounded-full bg-primaryColor text-white px-2">
                            {profile?.subscriber_count}
                          </span>
                        </button>
                      </div>
                    ) : !userId ? (
                      <div>
                        <button
                          type="button"
                          // onClick={handleSubscription}
                          onMouseEnter={handleMouseEnter2}
                          onMouseLeave={handleMouseLeave2}
                          style={{
                            color: isHovered2 ? "white" : "#004c50",
                            background: isHovered2 ? "#004C50" : "white",
                            width: "100%",
                            border: "1px solid #004c50",
                            borderRadius: "8px",
                            fontSize: "0.875rem",
                            padding: "0.59rem 1.05rem",
                            marginBottom: "0.5rem",
                            textAlign: "center",
                            outline: "none",
                            transition:
                              "background-color 0.2s, border-color 0.2s",
                          }}
                          className="font-bold"
                        >
                          SUBSCRIPTIONS{" "}
                          <span className="rounded-full bg-primaryColor text-white px-2">
                            {profile?.subscriber_count}
                          </span>
                        </button>
                      </div>
                    ) : (
                      userId !== user_id && ""
                    )
                  ) : null}

                  {profile?.green_tick && SUBSCRIPTION_ENABLED ? (
                    <>
                      {userId &&
                      userId !== user_id &&
                      !profile?.is_subscribed ? (
                        <div>
                          <button
                            type="button"
                            onClick={handleSubscription}
                            onMouseEnter={handleMouseEnter2}
                            onMouseLeave={handleMouseLeave2}
                            style={{
                              color: isHovered2 ? "white" : "white",
                              background: isHovered2 ? "#004C50" : "#004C50",
                              width: "100%",
                              border: "1px solid #004c50",
                              borderRadius: "8px",
                              fontSize: "0.875rem",
                              padding: "0.59rem 1.05rem",
                              textAlign: "center",
                              marginBottom: "0.5rem",
                              outline: "none",
                              transition:
                                "background-color 0.2s, border-color 0.2s",
                            }}
                            className="font-bold"
                          >
                            SUBSCRIBE
                          </button>
                        </div>
                      ) : (
                        profile?.is_subscribed && (
                          <div>
                            <button
                              type="button"
                              onMouseEnter={handleMouseEnter2}
                              onMouseLeave={handleMouseLeave2}
                              style={{
                                color: isHovered2 ? "white" : "white",
                                background: isHovered2 ? "#004C50" : "#004C50",
                                width: "100%",
                                border: "1px solid #004c50",
                                borderRadius: "8px",
                                fontSize: "0.875rem",
                                padding: "0.59rem 1.05rem",
                                marginBottom: "0.5rem",
                                textAlign: "center",
                                outline: "none",
                                transition:
                                  "background-color 0.2s, border-color 0.2s",
                              }}
                              className="font-bold"
                            >
                              SUBSCRIBED
                            </button>
                          </div>
                        )
                      )}
                    </>
                  ) : (
                    <div className="mt-2"></div>
                  )}
                </div>
                <div className="w-full">
                  {userId !== user_id ? renderButton() : ""}
                </div>
                <div></div>

                {!game_id && (
                  <>
                    {/* <ProfileTop /> */}
                    <div className="w-full mt-3 h-px bg-gray-300"></div>{" "}
                    {loading ? (
                      <Loader dark />
                    ) : (
                      <div className={isMobileView && " mb-12 -mx-2 w-[calc(100%+1rem)]"}>
                        <InfiniteScroll
                          dataLength={posts.length}
                          next={posts.length > 9 && handleLoadMore}
                          hasMore={hasMore}
                          loader={loader && <SmallLoader />}
                          style={{
                            overflow: "hidden",
                          }}
                          endMessage={
                            !hasMore && (
                              <p style={{ textAlign: "center" }}>
                                <b>Yay! You have seen it all</b>
                              </p>
                            )
                          }
                        >
                          {posts.length > 0 ? (
                            <>
                              {posts
                                .filter((post) => !post.game_id)
                                .map((post, index) => {
                                  return isMobileView ? (
                                    <div
                                      key={index}
                                      className="w-full bg-white"
                                    >
                                      <div className="py-3.5 px-[18px] flex items-center justify-between gap-2 ">
                                        <div className="flex items-center gap-2">
                                          <div
                                            className={
                                              isMobileView ? "w-10" : ""
                                            }
                                          >
                                            <Link
                                              to={
                                                post?.repost?.id
                                                  ? `/profile/${post?.repost?.user?.id}`
                                                  : ""
                                              }
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                className="w-8 h-8 rounded-full border border-[#f0f2f5] object-cover"
                                                alt={`${
                                                  post?.repost?.id
                                                    ? post?.repost?.user
                                                        ?.user_name
                                                    : post.user.user_name
                                                }'s profile`}
                                              />
                                            </Link>
                                          </div>
                                          <div className="text-[15px] font-semibold block leading-tight">
                                            {/* <span
                                                className={
                                                isMobileView
                                                    ? "ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                    : "px-1 ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                }
                                            >
                                                {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span> */}

                                            <span className="text-[15px] font-semibold block leading-tight">
                                              {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span>
                                            {profile.green_tick ? (
                                              <img
                                                src={GreenTick}
                                                className="ml-1 w-5 h-5"
                                                alt="green-tick"
                                              />
                                            ) : // <FontAwesomeIcon icon={faCheckCircle} className="px-1 text-xl md:text-2xl text-primaryColor" />
                                            null}

                                            {post?.repost?.id && (
                                              <span className="text-[11px] font-medium text-[#888888] block">
                                                {post?.user?.user_name} Reposted
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <div className="flex items-center justify-between ">
                                          {userId == user_id ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                            >
                                              <span
                                                onClick={() =>
                                                  toggleDropdown(index)
                                                }
                                                type="button"
                                                className="cursor-pointer"
                                              >
                                                {TheDotsIcon}
                                              </span>
                                              {dropdownStates[index] && (
                                                <div style={{ zIndex: 1 }} className="z-50 absolute top-8 text-green-500 left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : !userId ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                            >
                                              <span
                                                onClick={() =>
                                                  toggleDropdown(index)
                                                }
                                                type="button"
                                                className="cursor-pointer"
                                              >
                                                {TheDotsIcon}
                                              </span>
                                              {dropdownStates[index] && (
                                                <div style={{ zIndex: 1 }} className="absolute top-8 text-green-500 left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>

                                      <div
                                        className="w-full bg-white"
                                      >
                                                                          {post.post_image?.length > 0 ||
                                  post?.repost?.post_image?.length > 0 ? (
                                    post?.repost?.id ? (
                                      post?.repost?.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];

                                          return (
                                            <div
                                              key={imageIndex}
                                              className="p-0 pswp-gallery"
                                            >
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div className="relative" onClick={() => togglePlay(post.id)}
                                                >
                                                {isLoadingVideo[post.id] && (
  <div className="absolute inset-0 flex items-center justify-center bg-[#f8f8f8]">
    <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
)}
                                                  {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                      className="w-full"
                                                    />
                                                    <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick1(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button>
                                                    </div>
                                                  ) : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      autoPlay
                                                      playsInline
                                                      controls
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>

                                                  )} */}

    {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

<video
  id={post.id}
  ref={(el) => (videosRef.current[post.id] = el)}
  poster={image.thumb}
  src={image.image}
  className="w-full max-h-full object-contain"
  onMouseEnter={() => handleVisibility(post.id, true)}
  onMouseLeave={() => handleVisibility(post.id, false)}
  onClick={() => togglePlay(post.id)}
  loop
  playsInline
  webkit-playsinline="true"
  x5-playsinline="true"
  x-webkit-airplay="deny"
  disablePictureInPicture={true}
  preload="auto"
  autoPlay // ✅ Autoplay enabled
  muted={isMuted} // ✅ Controlled mute state
      onLoadedMetadata={(e) => {
        e.target.setAttribute("playsinline", "true"); // ✅ Force playsInline for iOS
        e.target.setAttribute("muted", "true"); // ✅ Ensure it's muted
        e.target.play().catch((err) => console.warn("Autoplay blocked", err));
        handleVideoCanPlay(post.id,true); // ✅ Call earlier
      }}
      // onCanPlay={(e) => {
      //   console.log(`Video ${post.id} can play now`);
      //   e.target.play(); // ✅ Force play
      //   handleVideoCanPlay(post.id);
      // }}
      onLoadedData={() => handleVideoCanPlay(post.id,true)}
  // onPlay={() => setIsLoading(false)}
/>


              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                </div>
                                              ) : (
                                                <a
                                                  href={image.image}
                                                  key={`image-${imageIndex}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={image.image}
                                                    alt={`Post Image ${
                                                      imageIndex + 1
                                                    }`}
                                                    className="w-full"
                                                    onLoad={(event) =>
                                                      handleImageLoaded(
                                                        event,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </a>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    ) : (
                                      post.post_image.map(
                                        (image, imageIndex) => {
                                          const key = `${index}-${imageIndex}`;
                                          const shouldShowThumbnail =
                                            !showVideos[key] &&
                                            !videoPlaying[key];

                                          return (
                                            <div
                                              key={imageIndex}
                                              className="p-0 pswp-gallery"
                                            >
                                              {videoExtensionsRegex.test(
                                                image.image.split("?")[0]
                                              ) ? (
                                                <div className="relative" onClick={() => togglePlay(post.id)}
                                                >
                                                {isLoadingVideo[post.id] && (
  <div className="absolute inset-0 flex items-center justify-center bg-[#f8f8f8]">
    <div className="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
)}
                                                  {/* {shouldShowThumbnail ? (
                                                    <div className="relative">
                                                    <img
                                                      src={image.thumb}
                                                      id={`image-${key}`}
                                                      className={"w-full"}
                                                      alt="Video Thumbnail"
                                                      onClick={() =>
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        )
                                                      }
                                                    />
                                                    <button
                                                    id={`play-button-${key}`}
                                                    className={
                                                      videoPlaying[key]
                                                        ? "absolute inset-0 flex rounded-lg items-center justify-center text-white"
                                                        : "absolute inset-0 flex  items-center justify-center bg-black bg-opacity-10 text-white"
                                                    }
                                                    style={{
                                                      display: videoPlaying[key]
                                                        ? "none"
                                                        : "block",
                                                    }}
                                                    onClick={() => {
                                                      handleVideoClick1(
                                                        index,
                                                        imageIndex
                                                      );
                                                    }}
                                                  >
                                                    {videoPlaying[key] ? (
                                                      ""
                                                    ) : (
                                                      <FontAwesomeIcon
                                                        className="h-7"
                                                        icon={
                                                          videoPlaying[key]
                                                            ? faPause
                                                            : faPlay
                                                        }
                                                      />
                                                    )}
                                                  </button>
                                                    </div>
                                                  ) : (
                                                    <video
                                                      ref={(el) =>
                                                        (videoRefs.current[
                                                          key
                                                        ] = el)
                                                      }
                                                      autoPlay
                                                      playsInline
                                                      controls
                                                      className="w-full"
                                                      onClick={(e) => {
                                                        e.target.currentTime = 0;
                                                        handleVideoClick1(
                                                          index,
                                                          imageIndex
                                                        );
                                                      }}
                                                    >
                                                      <source
                                                        src={image.image}
                                                      />
                                                    </video>
                                                  )} */}

                                                                                                      {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

<video
  id={post.id}
  ref={(el) => (videosRef.current[post.id] = el)}
  poster={image.thumb}
  src={image.image}
  className="w-full max-h-full object-contain"
  onMouseEnter={() => handleVisibility(post.id, true)}
  onMouseLeave={() => handleVisibility(post.id, false)}
  onClick={() => togglePlay(post.id)}
  loop
  playsInline
  webkit-playsinline="true"
  x5-playsinline="true"
  x-webkit-airplay="deny"
  disablePictureInPicture={true}
  preload="auto"
  autoPlay // ✅ Autoplay enabled
  muted={isMuted} // ✅ Controlled mute state
      onLoadedMetadata={(e) => {
        e.target.setAttribute("playsinline", "true"); // ✅ Force playsInline for iOS
        e.target.setAttribute("muted", "true"); // ✅ Ensure it's muted
        e.target.play().catch((err) => console.warn("Autoplay blocked", err));
        handleVideoCanPlay(post.id,true); // ✅ Call earlier
      }}
      // onCanPlay={(e) => {
      //   console.log(`Video ${post.id} can play now`);
      //   e.target.play(); // ✅ Force play
      //   handleVideoCanPlay(post.id);
      // }}
      onLoadedData={() => handleVideoCanPlay(post.id,true)}
  // onPlay={() => setIsLoading(false)}
/>


              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                </div>
                                              ) : (
                                                <a
                                                  href={image.image}
                                                  key={`image-${imageIndex}`}
                                                  target="_blank"
                                                  rel="noopener noreferrer"
                                                >
                                                  <img
                                                    src={image.image}
                                                    alt={`Post Image ${
                                                      imageIndex + 1
                                                    }`}
                                                    className="w-full"
                                                    onLoad={(event) =>
                                                      handleImageLoaded(
                                                        event,
                                                        index
                                                      )
                                                    }
                                                  />
                                                </a>
                                              )}
                                            </div>
                                          );
                                        }
                                      )
                                    )
                                  ) : (
                                    <div className="py-3.5 px-[18px] bg-white">
                                      <p className="text-base whitespace-pre-line font-medium text-black">
                                        {" "}
                                        {post?.repost?.id ? (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                  <>...<button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] ml-1"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                    </>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        ) : (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                    <>...<button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] ml-1"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                </>)}
                                                </>
                                              );
                                            })()}
                                          </>
                                        )}
                                      </p>
                                    </div>
                                  )}

                                        {preview && (
                                          <div
                                            style={{
                                              position: "fixed",
                                              top: 0,
                                              left: 0,
                                              width: "100%",
                                              height: "100%",
                                              backgroundColor:
                                                "rgba(0, 0, 0, 0.5)",
                                              opacity: "1",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              zIndex: 1000, // Set a higher value to ensure it's above the sidebar
                                            }}
                                            onClick={() => setPreview(false)}
                                          >
                                            <TransformWrapper
                                              defaultScale={1}
                                              defaultPositionX={200}
                                              defaultPositionY={100}
                                              className="flex items-center justify-center"
                                            >
                                              {({
                                                zoomIn,
                                                zoomOut,
                                                resetTransform,
                                                positionX,
                                                positionY,
                                                ...rest
                                              }) => (
                                                <>
                                                  <TransformComponent className="flex items-center justify-center">
                                                    <img
                                                      src={activeImage}
                                                      alt="Preview"
                                                      className={
                                                        isMobileView
                                                          ? "ml-3"
                                                          : "ml-6"
                                                      }
                                                      style={{
                                                        maxWidth: "95%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain",
                                                      }}
                                                    />
                                                  </TransformComponent>
                                                </>
                                              )}
                                            </TransformWrapper>
                                          </div>
                                        )}
                                      </div>
                                      <div className="p-4 space-y-2">
                                      <div className="flex items-center justify-between">
                                      <div className="flex items-center gap-4">

                                      <button
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post.total_likes
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >

                                          {post?.repost?.id
                                            ? post?.repost?.is_like_by_me
                                              ? HeartFilledIcon
                                              : HeartIcon
                                            : post?.is_like_by_me
                                            ? HeartFilledIcon
                                            : HeartIcon}

                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>

                                        </button>

                                        <button
                                          onClick={() =>
                                            handleCommentToggle(
                                              index,
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {CommentIcon}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_comments
                                              : post.total_comments}
                                          </p>
                                        </button>

                                        <button
                                          onClick={() =>
                                            handleShare(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon
                                            icon={faArrowUpFromBracket}
                                          />
                                        </button>


                                                                                <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleRepost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post,
                                              post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          {RepostIcon}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.repost_count
                                              : post.repost_count}
                                          </p>
                                        </button>


</div>

                                        {/* <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post?.repost?.id
                                                ? post?.repost?.total_likes
                                                : post.total_likes
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {post?.repost?.id ? (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.repost?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          ) : (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          )}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>
                                        </button> */}
                                      <button
                                        disabled={isDisabled ? true : false}
                                        onClick={() =>
                                          handleSavePost(
                                            post?.repost?.id
                                              ? post?.repost?.id
                                              : post.id
                                          )
                                        }
                                      >
                                        {post?.repost?.id ? (
                                              post?.repost?.is_saved
                                                ? <>{SaveIconFill}</>
                                                :  <>{SaveIcon}</>
                                        ) : (
                                              post.is_saved ? <>{SaveIconFill}</>
                                                :<> {SaveIcon}</>
                                        )}
                                      </button>

                                        {/* <button className="flex flex-row justify-center items-center ">
                                        <FontAwesomeIcon icon={faChartSimple} />
                                        <p className="ml-1 md:text-xs text-xxs">2,434</p>
                                        </button> */}
                                        {isModalOpen && (
                                          <div
                                            className={
                                              isMobileView
                                                ? "fixed top-0 left-0 h-full flex items-center justify-center right-5"
                                                : "fixed top-0 left-0 w-full h-full flex items-center justify-center"
                                            }
                                          >
                                            <div className="bg-white p-6 rounded shadow-lg text-center">
                                              {/* Modal content goes here */}
                                              <div className="flex justify-center items-center my-2">
                                                <img
                                                  src={"/qushi_logo.png"}
                                                  className="h-24"
                                                  alt="logo"
                                                />
                                              </div>
                                              <p className="mb-4 text-primaryColor">
                                                Are you sure you want to delete
                                                this post?
                                              </p>
                                              <div className="flex justify-center">
                                                <button
                                                  disabled={
                                                    isDisabled ? true : false
                                                  }
                                                  onClick={handleDelete}
                                                  className="bg-primaryColor text-white py-2 px-4 rounded mr-2"
                                                >
                                                  Delete Post
                                                </button>
                                                <button
                                                  onClick={handleCloseModal}
                                                  className="bg-red-500 text-white py-2 px-4 rounded"
                                                >
                                                  Cancel
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                      <p>
                                      <span className="text-sm font-semibold">
                                        {/* {post?.repost?.id
                                          ? post?.repost?.total_likes
                                          : post.total_likes}{" "}
                                        likes */}
                                        {post?.user?.user_name}
                                      </span>{" "}
                                      <span className="text-[#888888] px-2">
                                        ·
                                      </span>
                                      <span className="text-[#888888] text-[12px] font-semibold">
                                        {calculateTimeDifference(
                                          post?.repost?.id
                                            ? post?.repost?.created_at
                                            : post.created_at
                                        )}
                                      </span>
                                    </p>
                                    {post.post_image?.length > 0 && (
                                      <p className="text-base font-medium whitespace-pre-line text-black">
                                        {" "}
                                        {post?.repost?.id ? (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                  <>...<button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888] ml-1"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                    </>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </>
                                        ) : (
                                          <>
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                      <>
                                                    ... <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-[#888888]"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "less"
                                                        : "more"}
                                                    </button>
                                                  </>)}
                                                </>
                                              );
                                            })()}
                                          </>
                                        )}
                                      </p>
                                    )}

                                      {commentOpenStates[index] && (
                                        <div className="mt-4 text-black ml-[20px] md:ml-[60px] lg:ml-[60px]">
                                          <div className="mt-4 space-y-2">
                                            {postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ] &&
                                            postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ].length > 0 ? (
                                              postComments[
                                                post?.repost?.id
                                                  ? post?.repost?.id
                                                  : post.id
                                              ].map((comment) => (
                                                <div
                                                  key={comment.id}
                                                  className="flex items-start mb-2"
                                                >
                                                  <div className="flex-shrink-0">
                                                    <img
                                                      src={comment?.user?.image}
                                                      alt={`${comment?.user?.user_name}'s avatar`}
                                                      className="w-8 h-8 rounded-full mr-2"
                                                    />
                                                  </div>
                                                  <div className="w-full">
                                                    <div className="flex justify-between mb-1">
                                                      <span className="font-semibold ml-2">
                                                        {
                                                          comment?.user
                                                            ?.user_name
                                                        }
                                                      </span>

                                                      {comment?.user.id ===
                                                        userInfo?.id && (
                                                        <button
                                                          disabled={
                                                            isDisabled
                                                              ? true
                                                              : false
                                                          }
                                                          className="px-5 text-green-500"
                                                          onClick={() =>
                                                            handleDeleteComment(
                                                              comment.id
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faTrash}
                                                          />
                                                        </button>
                                                      )}
                                                    </div>
                                                    <div className="flex justify-between">
                                                      <div
                                                        className={
                                                          "md:w-full w-52 ml-2"
                                                        }
                                                      >
                                                        <p className="w-full break-words text-sm"   style={{
                                                            whiteSpace: 'pre-wrap', // Ensures that spaces and newlines are preserved
                                                            wordBreak: 'break-word', // Breaks long words if necessary to prevent overflow
                                                          }}>
                                                          {comment?.comment}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            ) : loadingComment ? (
                                              <SmallLoader />
                                            ) : (
                                              <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                                <p>No comments yet</p>
                                              </div>
                                            )}
                                          </div>

                                          <div className="flex">
                                            {/* <input
                                              type="text"
                                              value={newComment}
                                              onChange={(e) =>
                                                setNewComment(e.target.value)
                                              }
                                              placeholder="Add a comment..."
                                              className="p-2 border border-emerald-500 rounded w-full text-black"
                                              style={{ flex: 1 }} // Ensures the input takes up remaining space
                                            /> */}
                                              <textarea
                                                        value={newComment}
                                                        onChange={(e) => setNewComment(e.target.value)}
                                                        placeholder="Add a comment..."
                                                        className="p-2 border border-emerald-500 rounded w-full text-black"
                                                        style={{ flex: 1, resize: 'vertical' }} // Allows resizing vertically
                                                        rows={3} // You can adjust this number
                                              />
                                            <button
                                              className="ml-2 bg-primaryColor mt-2 text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                              disabled={
                                                isDisabled ? true : false
                                              }
                                              onClick={() =>
                                                handleAddComment(
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id,
                                                  index
                                                )
                                              }
                                              style={{
                                                height: 30,
                                                minWidth: 84, // Set a minimum width for the button
                                              }}
                                            >
                                              Submit
                                            </button>
                                          </div>
                                        </div>
                                      )}
                              {(post?.repost?.id ? post?.repost?.total_comments : post.total_comments) >= 1 && (
                                <p
                                  onClick={() =>
                                    handleCommentToggle(
                                      index,
                                      post?.repost?.id ? post?.repost?.id : post.id
                                    )
                                  }
                                  className="cursor-pointer text-[#888888]"
                                >
                                  View all{" "}
                                  <span>
                                    {post?.repost?.id ? post?.repost?.total_comments : post.total_comments}
                                  </span>{" "}
                                  comments
                                </p>
                              )}
                              </div>
                                      <div className="w-full mt-3 h-px bg-gray-300"></div>{" "}
                                    </div>
                                  ) : (
                                    <div
                                      key={index}
                                      className={
                                        isMobileView
                                          ? "text-white px-2 py-2  flex flex-col"
                                          : "text-white p-4  flex flex-col"
                                      }
                                    >
                                      {post?.repost?.id && (
                                        <div className="mt-4 text-black">
                                          <div className="flex items-center mb-2 ml-12">
                                            <FontAwesomeIcon
                                              className="text-primaryColor mr-2"
                                              icon={faRepeat}
                                            />
                                            <p
                                              className="text-md font-bold"
                                              style={{ color: "#004c50" }}
                                            >
                                              {post?.user?.user_name} Reposted
                                            </p>
                                          </div>
                                        </div>
                                      )}
                                      <div className="flex items-center mb-2 justify-between">
                                        <div className="flex items-center">
                                          <div
                                            className={
                                              isMobileView ? "w-10" : ""
                                            }
                                          >
                                            <Link
                                              to={
                                                post?.repost?.id
                                                  ? `/profile/${post?.repost?.user?.id}`
                                                  : ""
                                              }
                                              className={
                                                isMobileView ? "w-10" : ""
                                              }
                                            >
                                              <img
                                                src={
                                                  post?.repost?.id
                                                    ? post?.repost?.user?.image
                                                    : post?.user?.image
                                                }
                                                className={
                                                  isMobileView
                                                    ? "object-cover h-10 w-full mr-2 rounded-full"
                                                    : "object-cover h-10 w-10  rounded-full"
                                                }
                                                alt={`${
                                                  post?.repost?.id
                                                    ? post?.repost?.user
                                                        ?.user_name
                                                    : post.user.user_name
                                                }'s profile`}
                                              />
                                            </Link>
                                          </div>
                                          <div className="flex">
                                            {/* <span
                                                className={
                                                isMobileView
                                                    ? "ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                    : "px-1 ml-2 text-[13px] text-black font-bold font-poppins whitespace-nowrap"
                                                }
                                            >
                                                {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span> */}

                                            <span
                                              className={
                                                isMobileView
                                                  ? "px-1 -mt-1.5 text-[20px] text-black font-bold font-poppins truncate"
                                                  : "px-1 text-[20px] text-black font-bold font-poppins truncate"
                                              }
                                            >
                                              @
                                              {post?.repost?.id
                                                ? post?.repost?.user?.user_name
                                                : post.user.user_name}
                                            </span>
                                            {profile.green_tick ? (
                                              <img
                                                src={GreenTick}
                                                className="ml-1 w-5 h-5"
                                                alt="green-tick"
                                              />
                                            ) : // <FontAwesomeIcon icon={faCheckCircle} className="px-1 text-xl md:text-2xl text-primaryColor" />
                                            null}
                                          </div>
                                        </div>
                                        <div className="flex">
                                          <span
                                            className={
                                              isMobileView
                                                ? "ml-[10px] mt-1 truncate white text-base text-gray-600 font-poppins"
                                                : "md:ml-[313px] ml-[80px] mt-1 truncate white text-base text-gray-600 font-poppins"
                                            }
                                          >
                                            {calculateTimeDifference(
                                              post?.repost?.id
                                                ? post?.repost?.created_at
                                                : post.created_at
                                            )}
                                          </span>
                                          {userId == user_id ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                            >
                                              <button
                                                onClick={() =>
                                                  toggleDropdown(index)
                                                }
                                                type="button"
                                                className={
                                                  isMobileView
                                                    ? "z-50 px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                    : "z-50 px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                }
                                                style={{ zIndex: 7 }}
                                              >
                                                <FontAwesomeIcon
                                                  icon={
                                                    isMobileView
                                                      ? faEllipsisV
                                                      : faEllipsisH
                                                  }
                                                  className=""
                                                />
                                              </button>
                                              {dropdownStates[index] && (
                                                <div style={{ zIndex: 1 }} className="z-50 absolute top-8 text-green-500 left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : !userId ? (
                                            <div
                                              style={{ position: "relative" }}
                                              className="ml-4"
                                            >
                                              <button
                                                onClick={() =>
                                                  toggleDropdown(index)
                                                }
                                                type="button"
                                                className={
                                                  isMobileView
                                                    ? "px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                    : "px-4 py-2 bg-white-400 text-green-700 rounded hover:bg-primaryColor hover:text-white flex items-center"
                                                }
                                                style={{ zIndex: 7 }} // Ensure button is above the dropdown
                                              >
                                                <FontAwesomeIcon
                                                  icon={
                                                    isMobileView
                                                      ? faEllipsisV
                                                      : faEllipsisH
                                                  }
                                                  className=""
                                                />
                                              </button>
                                              {dropdownStates[index] && (
                                                <div style={{ zIndex: 1 }} className="absolute top-8 text-green-500 left-0 w-10 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 md:mr-[220px] mr-[20px]">
                                                  <button
                                                    onClick={() =>
                                                      handleDeletePost(post.id)
                                                    }
                                                    className="block text-primaryColor px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900"
                                                    role="menuitem"
                                                  >
                                                    <div className="flex flex-row justify-center items-center">
                                                      <FontAwesomeIcon
                                                        icon={faTrash}
                                                      />
                                                    </div>
                                                  </button>
                                                  {post?.repost?.id ? (
                                                    ""
                                                  ) : (
                                                    <button
                                                      onClick={() =>
                                                        handleEditClick(
                                                          post?.repost?.id
                                                            ? post?.repost?.id
                                                            : post.id
                                                        )
                                                      }
                                                      className="block px-4 py-2 text-sm text-primaryColor hover:bg-gray-100 hover:text-gray-900"
                                                      role="menuitem"
                                                    >
                                                      <div className="flex flex-row justify-center items-center">
                                                        <FontAwesomeIcon
                                                          icon={faEdit}
                                                        />
                                                      </div>
                                                    </button>
                                                  )}
                                                </div>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        className={
                                          isMobileView
                                            ? "ml-12 px-0 my-2 sm:px-10 font-poppins"
                                            : "ml-3 px-0 my-2 sm:px-10 font-poppins"
                                        }
                                      >
                                        {post?.repost?.id ? (
                                          <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                    <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-green-500 ml-2"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "Show less"
                                                        : "Show more"}
                                                    </button>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        ) : (
                                          <div className="text-[18px] font-poppins text-[#707070] whitespace-pre-line">
                                            {(() => {
                                              const getTrimmedDescription = (
                                                description,
                                                limit
                                              ) => {
                                                if (!description) return "";
                                                if (description.length <= limit)
                                                  return description;

                                                const trimmed =
                                                  description.substring(
                                                    0,
                                                    limit
                                                  );
                                                return (
                                                  trimmed.substring(
                                                    0,
                                                    trimmed.lastIndexOf(" ")
                                                  ) + " "
                                                );
                                              };

                                              const description =
                                                showFullDescription[index]
                                                  ? post?.description
                                                  : getTrimmedDescription(
                                                      post?.description,
                                                      255
                                                    );

                                              if (!description) {
                                                return null;
                                              }

                                              return (
                                                <>
                                                  {description}
                                                  {post?.description?.length >
                                                    255 && (
                                                    <button
                                                      onClick={() => {
                                                        setShowFullDescription(
                                                          (prevState) => {
                                                            const newState = [
                                                              ...prevState,
                                                            ];
                                                            newState[index] =
                                                              !newState[index];
                                                            return newState;
                                                          }
                                                        );
                                                      }}
                                                      className="text-green-500 ml-2"
                                                    >
                                                      {showFullDescription[
                                                        index
                                                      ]
                                                        ? "Show less"
                                                        : "Show more"}
                                                    </button>
                                                  )}
                                                </>
                                              );
                                            })()}
                                          </div>
                                        )}
                                      </div>
                                      <div
                                        className={
                                          isMobileView
                                            ? "ml-12  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                            : "ml-6  flex px-0 my-2 sm:px-10 flex-wrap pswp-gallery"
                                        }
                                      >
                                        {post?.repost?.id
                                          ? post?.repost?.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];
                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="mr-2 mb-2"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0]
                                                    ) ? (
                                                <div
                                                  className={`relative ${
                                                    post?.repost?.post_image.length == 1
                                                      ? isMobileView
                                                        ? "w-[300px] h-[350px] rounded-lg"
                                                        : "w-[780px] h-[400px] rounded-lg"
                                                      : isMobileView
                                                      ? "w-[300px] h-[350px] rounded-lg"
                                                      : "w-[780px] h-[400px] rounded-lg"
                                                  }`} onClick={() => togglePlay(post.id)}
                                                >

                                                    {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

                                                                                <video
                id={post.id}
                data-id={post.id}
                ref={(el) => (videosRef.current[post.id] = el)}
                poster={image.thumb}
                src={image.image}
                className="w-full max-h-full object-contain"
                // onMouseEnter={() => handleVisibility(post.id, true)}
                // onMouseLeave={() => handleVisibility(post.id, false)}
                onClick={() => togglePlay(post.id)}
                loop
                muted={isMuted}
                playsInline
                onLoadedData={() => handleVideoCanPlay(post.id,true)}
              />
              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                          style={linkStyles}
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            style={imageStyles}
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )
                                          : post.post_image.map(
                                              (image, imageIndex) => {
                                                const key = `${index}-${imageIndex}`;
                                                const shouldShowThumbnail =
                                                  !showVideos[key] &&
                                                  !videoPlaying[key];
                                                return (
                                                  <div
                                                    key={imageIndex}
                                                    className="mr-2 mb-2"
                                                  >
                                                    {videoExtensionsRegex.test(
                                                      image.image.split("?")[0]
                                                    ) ? (
                                                <div
                                                    className={`relative ${
                                                      post?.repost?.post_image.length == 1
                                                        ? isMobileView
                                                          ? "w-[300px] h-[350px] rounded-lg"
                                                          : "w-[780px] h-[400px] rounded-lg"
                                                        : isMobileView
                                                        ? "w-[300px] h-[350px] rounded-lg"
                                                        : "w-[780px] h-[400px] rounded-lg"
                                                    }`} onClick={() => togglePlay(post.id)}
                                                >
                                                        {/* {shouldShowThumbnail ? (
                                                          <div>
                                                            <img
                                                              src={image.thumb}
                                                              id={`image-${key}`}
                                                              className={
                                                                post?.post_image
                                                                  .length == 1
                                                                  ? isMobileView
                                                                    ? "w-[350px] h-[350px] object-contain rounded-lg "
                                                                    : "w-[780px] h-[400px] object-contain rounded-lg "
                                                                  : isMobileView
                                                                  ? "w-[350px] h-[340px] object-contain rounded-lg "
                                                                  : "w-[780px] h-[400px] object-contain rounded-lg "
                                                              }
                                                              alt="Video Thumbnail"
                                                              onClick={(e) => {
                                                                handleVideoClick1(
                                                                  index,
                                                                  imageIndex
                                                                );
                                                              }}
                                                            />
                                                          </div>
                                                        ) : (
                                                          <video
                                                            ref={(el) =>
                                                              (videoRefs.current[
                                                                key
                                                              ] = el)
                                                            }
                                                            autoPlay
                                                            controls
                                                            autobuffer
                                                            playsInline={true}
                                                            webkit-playsinline="true"
                                                            x5-playsinline="true"
                                                            x-webkit-airplay="deny"
                                                            disablePictureInPicture={
                                                              true
                                                            }
                                                            controlsList="nodownload"
                                                            onContextMenu={(
                                                              e
                                                            ) =>
                                                              e.preventDefault()
                                                            }
                                                            preload="auto"
                                                            id={`video-${key}`}
                                                            controls
                                                            className="w-full h-full object-contain rounded-lg"
                                                            onClick={(e) => {
                                                              e.target.currentTime = 0;
                                                              handleVideoClick1(
                                                                index,
                                                                imageIndex
                                                              );
                                                            }}
                                                          >
                                                            <source
                                                              src={image.image}
                                                            />
                                                          </video>
                                                        )}

                                                        <button
                                                          id={`play-button-${key}`}
                                                          className={
                                                            videoPlaying[key]
                                                              ? "absolute  rounded-lg inset-0 flex items-center justify-center text-white"
                                                              : "absolute  rounded-lg inset-0 flex items-center justify-center bg-black bg-opacity-50 text-white"
                                                          }
                                                          style={{
                                                            display:
                                                              videoPlaying[key]
                                                                ? "none"
                                                                : "block",
                                                          }}
                                                          onClick={() =>
                                                            handleVideoClick1(
                                                              index,
                                                              imageIndex
                                                            )
                                                          }
                                                        >
                                                          {videoPlaying[key] ? (
                                                            ""
                                                          ) : (
                                                            <FontAwesomeIcon
                                                              className="h-7"
                                                              icon={
                                                                videoPlaying[
                                                                  key
                                                                ]
                                                                  ? faPause
                                                                  : faPlay
                                                              }
                                                            />
                                                          )}
                                                        </button> */}
                                                                                                            {pausedVideoId === post.id && (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
      <FontAwesomeIcon
        icon={faPlay}
        className="text-green-500 text-3xl opacity-60"
      />
    </div>
  )}

                                                                              <video
                id={post.id}
                data-id={post.id}
                ref={(el) => (videosRef.current[post.id] = el)}
                poster={image.thumb}
                src={image.image}
                className="w-full max-h-full object-contain"
                // onMouseEnter={() => handleVisibility(post.id, true)}
                // onMouseLeave={() => handleVisibility(post.id, false)}
                onClick={() => togglePlay(post.id)}
                loop
                muted={isMuted}
                playsInline
                onLoadedData={() => handleVideoCanPlay(post.id,true)}
              />
              {/* Mute button positioned inside the post at the bottom-right corner */}
<button
  onClick={(e) => {
    e.stopPropagation(); // Prevent click from bubbling to parent
    toggleMute();
  }}
  className="absolute bottom-4 right-4 px-4 py-2 text-sm"
>
  {isMuted ? "🔇" : "🔊"}
</button>
                                                      </div>
                                                    ) : (
                                                      <div
                                                        id={`gallery-${post.id}`}
                                                        style={galleryStyles}
                                                      >
                                                        {" "}
                                                        <a
                                                          href={image.image}
                                                          key={`image-${imageIndex}`}
                                                          target="_blank"
                                                          rel="noopener noreferrer"
                                                          style={linkStyles}
                                                        >
                                                          <img
                                                            src={image.image}
                                                            alt={`Post Image ${
                                                              imageIndex + 1
                                                            }`}
                                                            style={imageStyles}
                                                            onLoad={(event) =>
                                                              handleImageLoaded(
                                                                event,
                                                                index
                                                              )
                                                            }
                                                          />
                                                        </a>
                                                      </div>
                                                    )}
                                                  </div>
                                                );
                                              }
                                            )}

                                        {preview && (
                                          <div
                                            style={{
                                              position: "fixed",
                                              top: 0,
                                              left: 0,
                                              width: "100%",
                                              height: "100%",
                                              backgroundColor:
                                                "rgba(0, 0, 0, 0.5)",
                                              opacity: "1",
                                              display: "flex",
                                              justifyContent: "center",
                                              alignItems: "center",
                                              zIndex: 1000, // Set a higher value to ensure it's above the sidebar
                                            }}
                                            onClick={() => setPreview(false)}
                                          >
                                            <TransformWrapper
                                              defaultScale={1}
                                              defaultPositionX={200}
                                              defaultPositionY={100}
                                              className="flex items-center justify-center"
                                            >
                                              {({
                                                zoomIn,
                                                zoomOut,
                                                resetTransform,
                                                positionX,
                                                positionY,
                                                ...rest
                                              }) => (
                                                <>
                                                  <TransformComponent className="flex items-center justify-center">
                                                    <img
                                                      src={activeImage}
                                                      alt="Preview"
                                                      className={
                                                        isMobileView
                                                          ? "ml-3"
                                                          : "ml-6"
                                                      }
                                                      style={{
                                                        maxWidth: "95%",
                                                        maxHeight: "100%",
                                                        objectFit: "contain",
                                                      }}
                                                    />
                                                  </TransformComponent>
                                                </>
                                              )}
                                            </TransformWrapper>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex flex-row md:ml-8 ml-[2.8rem] justify-between items-center px-4 sm:px-8 my-4 text-green-500 space-x-4">
                                        <button
                                          onClick={() =>
                                            handleCommentToggle(
                                              index,
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon icon={empty2} />
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_comments
                                              : post.total_comments}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleRepost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post,
                                              post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          <FontAwesomeIcon icon={faRepeat} />
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.repost_count
                                              : post.repost_count}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleLikeDislike(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id,
                                              post?.repost?.id
                                                ? post?.repost?.total_likes
                                                : post.total_likes
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          {post?.repost?.id ? (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.repost?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          ) : (
                                            <FontAwesomeIcon
                                              icon={
                                                post?.is_like_by_me
                                                  ? faHeart
                                                  : empty
                                              }
                                            />
                                          )}
                                          <p className="ml-1 md:text-xs text-base">
                                            {post?.repost?.id
                                              ? post?.repost?.total_likes
                                              : post.total_likes}
                                          </p>
                                        </button>
                                        <button
                                          disabled={isDisabled ? true : false}
                                          onClick={() =>
                                            handleSavePost(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center "
                                        >
                                          <FontAwesomeIcon
                                            icon={
                                              post?.repost?.is_saved ||
                                              post.is_saved
                                                ? saved
                                                : faBookmark // This will be used if post or repost is not saved
                                            }
                                          />
                                        </button>

                                        {/* <button className="flex flex-row justify-center items-center ">
                                        <FontAwesomeIcon icon={faChartSimple} />
                                        <p className="ml-1 md:text-xs text-xxs">2,434</p>
                                        </button> */}
                                        {isModalOpen && (
                                          <div
                                            className={
                                              isMobileView
                                                ? "fixed top-0 left-0 h-full flex items-center justify-center right-5"
                                                : "fixed top-0 left-0 w-full h-full flex items-center justify-center"
                                            }
                                          >
                                            <div className="bg-white p-6 rounded shadow-lg text-center">
                                              {/* Modal content goes here */}
                                              <div className="flex justify-center items-center my-2">
                                                <img
                                                  src={"/qushi_logo.png"}
                                                  className="h-24"
                                                  alt="logo"
                                                />
                                              </div>
                                              <p className="mb-4 text-primaryColor">
                                                Are you sure you want to delete
                                                this post?
                                              </p>
                                              <div className="flex justify-center">
                                                <button
                                                  disabled={
                                                    isDisabled ? true : false
                                                  }
                                                  onClick={handleDelete}
                                                  className="bg-primaryColor text-white py-2 px-4 rounded mr-2"
                                                >
                                                  Delete Post
                                                </button>
                                                <button
                                                  onClick={handleCloseModal}
                                                  className="bg-red-500 text-white py-2 px-4 rounded"
                                                >
                                                  Cancel
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                        <button
                                          onClick={() =>
                                            handleShare(
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            )
                                          }
                                          className="flex flex-row justify-center items-center"
                                        >
                                          <FontAwesomeIcon
                                            icon={faArrowUpFromBracket}
                                          />
                                        </button>
                                      </div>
                                      {commentOpenStates[index] && (
                                        <div className="mt-4 text-black ml-[20px] md:ml-[60px] lg:ml-[60px]">
                                          <div className="mt-4 space-y-2">
                                            {postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ] &&
                                            postComments[
                                              post?.repost?.id
                                                ? post?.repost?.id
                                                : post.id
                                            ].length > 0 ? (
                                              postComments[
                                                post?.repost?.id
                                                  ? post?.repost?.id
                                                  : post.id
                                              ].map((comment) => (
                                                <div
                                                  key={comment.id}
                                                  className="flex items-start mb-2"
                                                >
                                                  <div className="flex-shrink-0">
                                                    <img
                                                      src={comment?.user?.image}
                                                      alt={`${comment?.user?.user_name}'s avatar`}
                                                      className="w-8 h-8 rounded-full mr-2"
                                                    />
                                                  </div>
                                                  <div className="w-full">
                                                    <div className="flex justify-between mb-1">
                                                      <span className="font-semibold ml-2">
                                                        {
                                                          comment?.user
                                                            ?.user_name
                                                        }
                                                      </span>

                                                      {comment?.user.id ===
                                                        userInfo?.id && (
                                                        <button
                                                          disabled={
                                                            isDisabled
                                                              ? true
                                                              : false
                                                          }
                                                          className="px-5 text-green-500"
                                                          onClick={() =>
                                                            handleDeleteComment(
                                                              comment.id
                                                            )
                                                          }
                                                        >
                                                          <FontAwesomeIcon
                                                            icon={faTrash}
                                                          />
                                                        </button>
                                                      )}
                                                    </div>
                                                    <div className="flex justify-between">
                                                      <div
                                                        className={
                                                          "md:w-full w-52 ml-2"
                                                        }
                                                      >
                                                        <p className="w-full break-words text-sm"   style={{
                                                              whiteSpace: 'pre-wrap', // Ensures that spaces and newlines are preserved
                                                              wordBreak: 'break-word', // Breaks long words if necessary to prevent overflow
                                                            }}>
                                                          {comment?.comment}
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              ))
                                            ) : loadingComment ? (
                                              <SmallLoader />
                                            ) : (
                                              <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                                                <p>No comments yet</p>
                                              </div>
                                            )}
                                          </div>

                                          <div className="flex">
                                            {/* <input
                                              type="text"
                                              value={newComment}
                                              onChange={(e) =>
                                                setNewComment(e.target.value)
                                              }
                                              placeholder="Add a comment..."
                                              className="p-2 border border-emerald-500 rounded w-full text-black"
                                              style={{ flex: 1 }} // Ensures the input takes up remaining space
                                            /> */}
                                                                                    <textarea
                                                value={newComment}
                                                onChange={(e) => setNewComment(e.target.value)}
                                                placeholder="Add a comment..."
                                                className="p-2 border border-emerald-500 rounded w-full text-black"
                                                style={{ flex: 1, resize: 'vertical' }} // Allows resizing vertically
                                                rows={3} // You can adjust this number
                                              />
                                            <button
                                              className="ml-2 bg-primaryColor mt-2 text-gray-200 hover:bg-primaryColor hover:text-white px-2 rounded-full focus:outline-none"
                                              disabled={
                                                isDisabled ? true : false
                                              }
                                              onClick={() =>
                                                handleAddComment(
                                                  post?.repost?.id
                                                    ? post?.repost?.id
                                                    : post.id,
                                                  index
                                                )
                                              }
                                              style={{
                                                height: 30,
                                                minWidth: 84, // Set a minimum width for the button
                                              }}
                                            >
                                              Submit
                                            </button>
                                          </div>
                                        </div>
                                      )}
                                      <div className="w-full mt-3 h-px bg-gray-300"></div>{" "}
                                    </div>
                                  );
                                })}
                              {/* <div>
                                {page !== last_page && (
                                    <div className="text-center">
                                    <button
                                        className="py-2 px-4 w-auto mt-2 mr-16 text-lg font-bold text-greenXD justify-end"
                                        onClick={handleLoadMore}
                                    >
                                        More
                                    </button>
                                    </div>
                                )}
                                </div> */}
                            </>
                          ) : (
                            <div className="text-center font-bold text-black py-4 px-4 mt-3 mb-4">
                              <p>No posts available</p>
                            </div>
                          )}
                        </InfiniteScroll>
                      </div>
                    )}
                    {/* </div> */}
                  </>
                )}
              </main>
            </div>
            <SubscriptionModal
              isOpen={isSubscribe}
              handleSubscribeCard={handleSubscribeCard}
              handleSubscribeCancel={handleSubscribeCancel}
            >
              <h className="text-lg font-bold text-primaryColor">
                You will be charged ${profile.subscription_plan_amount}
              </h>
              <p>Are you sure you want to subscribe!</p>
            </SubscriptionModal>
            <CardListForSubs
              openModal={openModal}
              isOpen={isOpenCardModal}
              isButtonDisabled={isButtonDisabled}
              handlePaymentCard={handlePaymentCard}
              handlePaymentCancel={handlePaymentCancel}
            >
              <AddCard
                isOpen={isAddModalOpen}
                setIsAddModalOpen={setIsAddModalOpen}
              >
                <Elements stripe={stripePromise}>
                  <CheckoutForm closeModal={closeModal} getCards={getCards} />
                </Elements>
              </AddCard>
              <List
                isChecked={isChecked}
                handlePrimaryValue={handlePrimaryValue}
                cards={cards}
              />
            </CardListForSubs>
            <ResetPortfolioModal
              isOpen={isPortfolioResetModalOpen}
              onClose={closeResetPortfolioModal}
              onConfirm={handleConfirm}
            />

            {isLoading && <PortfolioLoader />}

            {/* Stripe Modal */}
            {isStripeModalOpen && !isLoading && (
              <div className="stripe-modal">
                <Elements stripe={stripeResetPromise}>
                  <CheckoutPortfolioForm
                    profile={profile}
                    clientSecret={clientSecret}
                    onClose={handleStripeModalClose}
                  />
                </Elements>
              </div>
            )}
          </PageContainer>
        </>
      ) : loading ? (
        <Loader dark />
      ) : (
        ""
      )}
      <UndoRepostModal
        isOpen={postUndo}
        handleUndoRepost={handleUndoRepost}
        handleUndoCancel={handleUndoCancel}
      >
        <div className={"mb-4"}>
          <p>{"Are you sure you want to undo this reposted post?"}</p>
        </div>
      </UndoRepostModal>
      {isPreviewVideo && (
        <PreviewVideo src={attachments} onClick={handleCloseVideoClick} />
      )}
    </>
  );
};

export default ProfilePage;
